<template>
  <div id="menber_gain" class="menber_control menber_nav padding-30">
    <TabBar :list="tabList" :active="tabActive" @active="active"/>
    <div class="b_cont member_gain">
      <ul class="gain-list">
         <li v-for="item in list">
           <div :class="'gain-box theme' + item.coupon.theme">
            <div class="gain-left">
              <span class="price-unit">￥</span><span class="price-value">{{item.coupon.amount}}元</span>
              <p>
                <span v-if="item.coupon.thresholdtype === '01'">无限制</span>
                <span v-if="item.coupon.thresholdtype === '02'">满{{item.coupon.threshold}}元可用</span>
                <br>使用期限：{{item.coupon.beginTime | time}} - {{item.coupon.endTime | time}}
              </p>
            </div>
            <div class="gain-right">
              <div class="gain-name">{{item.coupon.name}}</div>
              <span class="gain-use" v-if="state === '01'">可使用</span>
              <span class="gain-use" v-if="state === '02'">已使用</span>
            </div>
          </div>
         </li>
         <li v-if="list.length===0" style="text-align: left;padding:10px;color: #999;">
           {{text}}
         </li>
      </ul>
      <div v-if="list.length>0">
        <Pagination :page="page" :pageSize="pageSize" :count="count" @change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar'
import Pagination from '@/components/Pagination'
export default {
  components: {
    TabBar,
    Pagination
  },
  data () {
    return {
      tabList: [
        {name: '可用优惠券', number: 0},
        {name: '已使用', number: 0}
      ],
      tabActive: 0,
      // 数据
      list: [],
      count: 0,
      page: 1,
      pageSize: 8,
      state: '01',
      amountCount: false,
      text: '加载中...'
    }
  },
  created () {
    this.get()
  },
  methods: {
    active (index) {
      this.tabActive = index
      this.page = 1
      if (parseInt(index) === 1) {
        this.state = '02'
      } else {
        this.state = '01'
      }
      this.get()
    },
    get () {
      var ctx = this
      window.$.ajax({
        url: '/rest/api/comm/gain/list?page=' + this.page + '&pageSize=' + this.pageSize + '&state=' + this.state + '&amountCount=' + this.amountCount + '&memberId=' + this.$store.state.info.data.memberId,
        success (res) {
          if (res.success) {
            var data = res.attributes.data
            ctx.list = data
            ctx.tabList[ctx.tabActive].number = res.attributes.count
            if (ctx.list.length === 0) {
              ctx.text = '暂无数据'
            } else {
              ctx.text = '加载中...'
            }
          }
        }
      })
    },
    changePage (page) {
      this.page = page
      this.get()
    }
  }
}
</script>

<style lang="css">
/*item*/
.gain-list{padding: 10px;background: #f5f6f7;overflow: hidden;}
.gain-list li{border:none;width: 50%;float:left;padding: 5px}
.gain-box{background:#fff;overflow:hidden;border-radius:3px;display:-webkit-box;display:-moz-box;display:-ms-box;display:-o-box;display:box;width:100%;position:relative}
.gain-left{padding:5px;width:70%;color:#999;font-size:12px;border-right:1px dashed #f50894;-webkit-box-pack:center;-moz-box-pack:left;-ms-box-pack:left;-o-box-pack:left;box-pack:left;-webkit-box-align:left;-moz-box-align:left;-ms-box-align:left;-o-box-align:left;box-align:left;text-align:left;-moz-box-flex:1;-webkit-box-flex:1;box-flex:1;box-shadow:1px 1px 2px rgba(0,0,0,.2)}
.gain-right{background:#f8386b;background:-moz-linear-gradient(left,#ea3062,#f8386b,#ea3062);background:-webkit-gradient(linear,left top,right top,from(#ea3062),color-stop(.5,#f8386b),to(#ea3062));background:-webkit-linear-gradient(left,#ea3062,#f8386b,#ea3062);background:-o-linear-gradient(left,#ea3062,#f8386b,#ea3062);padding:5px;width:30%;text-align:right;-webkit-box-pack:center;-moz-box-pack:left;-ms-box-pack:left;-o-box-pack:left;box-pack:left;-webkit-box-align:right;-moz-box-align:right;-ms-box-align:right;-o-box-align:right;box-align:right;text-align:right;-moz-box-flex:1;-webkit-box-flex:1;box-flex:1;color:#fff;box-shadow:1px 1px 2px rgba(0,0,0,.2)}
.price-unit{color:#f8386b}
.price-value{font-size:10px;color:#f8386b}
.gain-box:after{left:70%;top:-.25rem;content:'';display:block;position:absolute;background:#f4f4f4;border-radius:100%;width:.5rem;height:.5rem;margin-left:-.25rem;box-shadow:inset 1px 1px 1px 0 rgba(0,0,0,.1)}
.gain-box:before{left:70%;bottom:-.25rem;content:'';display:block;position:absolute;background:#f4f4f4;border-radius:100%;width:.5rem;height:.5rem;margin-left:-.25rem;box-shadow:inset 1px 1px 1px 0 rgba(0,0,0,.1)}
.pain-right-icon{display: inline-block;width: 10px;height: 10px;background: #fff;color: #f8386b;border-radius: 100%;vertical-align: middle;text-align: center;line-height: 0.75rem;margin-left: 0.2rem;padding-left:0.05rem;}
.gain-use{font-size: 12px;}
.theme2 .gain-right{background:#f90;}
.theme3 .gain-right{background:#96f;}
.theme4 .gain-right{background:#6c6;}
.theme5 .gain-right{background:#bcbcbc;}


@media (max-width:600px){
  .gain-list li{
    width: 100%
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Gain.vue